<template>

    <span class="text-green-rgba font-extrabold italic font-serif normal-case">t</span>
    <span class="text-blue-rgba font-extrabold font-sans uppercase">C</span>
    <span class="text-blue-rgba font-bold font-sans ">ontractor</span>


</template>
